import { render, staticRenderFns } from "./DictTree.vue?vue&type=template&id=4b284ff9&scoped=true"
import script from "./DictTree.vue?vue&type=script&lang=js"
export * from "./DictTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b284ff9",
  null
  
)

export default component.exports